// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_array from "../../../../node_modules/rescript/lib/es6/js_array.js";
import * as JsBindings$PorterinUtils from "../bindings/common/JsBindings.mjs";

function isIOS(param) {
  var devices = [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod",
    "MacIntel"
  ];
  var userDevice = JsBindings$PorterinUtils.isBrowser(undefined) ? window.navigator.platform : "";
  if (JsBindings$PorterinUtils.isBrowser(undefined)) {
    return Js_array.includes(userDevice, devices);
  } else {
    return false;
  }
}

export {
  isIOS ,
}
/* JsBindings-PorterinUtils Not a pure module */
